module.exports = __webpack_public_path__ + "static/media/img_uaic.e4c303b7.png";